module.exports = __webpack_public_path__ + "static/hoivakotilive_slide_6-f354def94c254d889332e98cbbb4a7f3.jpg";